<template>
  <main-layout>
    <v-layout wrap>
      <v-flex xs12>
        <v-card
          elevation="32"
          :raised="true"
          class="text-justify mb-4">

          <v-card-title class="align-end fill-height">Maker</v-card-title>
          <v-card-text class="mb-n5">
            <p>Curiosity is one of my core personality traits. I always feel the need to explore new concepts, ideas, locations, as well as create for a purpose. Whether it's solving a tangible user problem, or just one of mine, I like to explore my own creativity, skillset as well as expand it for the fun of it.</p>
            <p>Here's a small selection of ecclectic projects that I've dedicated myself to for some weeks or months:</p>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex
        v-for="(c, id, i) in projects"
        :key="id"
        xs12>
        <v-card
          :outlined="true"
          elevation="32"
          :raised="true">
          <v-flex
            v-if="$vuetify.breakpoint.smAndDown || (i % 2 == 0)"
            xs12
            md7
            class="d-inline-block">
            <v-img
              height="400px"
              :src="c.img"
            >
              <v-card-title :class="$vuetify.breakpoint.smAndDown?'picture_label':'picture_label picture_label_lg'">
                <v-icon v-if="c.icon !== undefined" class="white--text">{{ c.icon }}</v-icon>
                <span>&nbsp; {{ c.title }} - {{ c.year }}</span>
              </v-card-title>
            </v-img>
          </v-flex>
          <v-flex
            xs12
            md5
            class="d-inline-block"
            style="vertical-align: top">
            <v-card-text class="text-justify">
              <h3 class="mb-5">{{ c.tagline }}</h3>
              <p v-for="p in c.description" v-html="p"></p>
            </v-card-text>
            <v-card-actions v-if="c.links != undefined">
              <v-flex text-center>
                <v-btn v-for="l in c.links" :key="l.href" :href="l.href" color="primary" target="_blank">
                  <v-icon>{{ l.icon }}</v-icon>
                  &nbsp; 
                  {{ l.title }}
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-flex>
          <v-flex
            v-if="!($vuetify.breakpoint.smAndDown || (i % 2 == 0))"
            xs12
            md7
            class="d-inline-block">
            <v-img
              height="500px"
              :src="c.img"
            >
              <v-card-title :class="$vuetify.breakpoint.smAndDown?'picture_label':'picture_label picture_label_lg'">
                <v-icon v-if="c.icon !== undefined" class="white--text">{{ c.icon }}</v-icon>
                <span>&nbsp; {{ c.title }} - {{ c.year }}</span>
              </v-card-title>
            </v-img>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>
  </main-layout>
</template>

<script>
  import MainLayout from '../layouts/Main.vue'

  export default {
    name: "Maker",  
    components: {
      MainLayout
    },
    data: () => ({
      projects: {
        lunch_box: {
          icon: 'fa-archive',
          title: 'Wooden Lunch Box',
          year: 2018,
          img: require('../assets/maker/lunch_box.jpg'),
          tagline: 'Upcycling a wine crate into lunch box.',
          links: [
            {
              icon: 'fa-picture-o',
              href: 'https://photos.app.goo.gl/unajW73nMRqLBvEs5',
              title: 'More pictures'
            }
          ],
          description: [
            'Built froms heat-treated wine crates, this upcycling is my first wood work project. I wanted to keep the original carving of the box to evoke its upcycling charisma.',
            'The internal face of the cover contains a sliding case for foldable chopsticks, and is layered in food-grade sillicon to be waterproof.',
            'Finally, to ensure it can endure the challenge of time and moist, the wood is cured in walnut oil, giving it a heatful nutty aroma.',
            'Upcycling and creating an everyday use object: every steps counts toward a smaller carbon footprint.'
          ]
        },/*
        rasprivacy: {
          icon: 'fa-user-privacy',
          title: 'Rasprivacy privacy box',
          year: 2017,
          img: require('../assets/maker/rasprivacy.png'),
          tagline: 'Regain some privacy with a Raspberry PI.',
          links: [
            {
              icon: 'fa-download',
              href: 'https://docs.google.com/presentation/d/1S55-Y09QE4AQ4x5PT9I2RN4TNQdWvrBtXYiimx091VY/edit#slide=id.p',
              title: 'Full Schematics'
            }
          ],
          description: [
            'Built atop the <a href="http://yunohost.org" target="_blank">Yunohost</a> platform, Rasprivacy is a small app encapsulating 2 VPN configurations to encrypt End-to-End from any device you wish to a VPN exit node. Combined with HTTPs or SFTP for full End-to-End encryption.',
            'It secures 2 end point: a LAN for local/house devices, as well as a VPN server for external connections, such as a mobile device on the go.',
            'To ease management, a Yunohost administration UI enables the service, the various LAN interfaces as well as the VPN setup to exit securely to a remote location.',
            'My personal full node also includes a DNS server to block ads, a Mail server as well as Firefox server to store personal day-to-day data.' 
          ]
        },*/
        casual_cards: {
          icon: 'fa-id-card',
          title: 'Casual Cards Concept',
          year: 2013,
          img: require('../assets/maker/casual-cards.jpg'),
          tagline: 'Transform a personal object of yours into a name card.',
          description: [
            'Casual cards are an original idea that you can meet people outside business context, and want to be able to distinguish every single of these encounters. The best support for casual cards are personal items, such as flight tickets: they are one-time use and nominative, ensuring each person is unique, and your encounter is marked as such.',
            'Casual cards bring back identity to name cards.'
          ]
        },
        veliby: {
          icon: 'fa-biking',
          title: 'Veliby Android App',
          year: 2012,
          img: require('../assets/maker/veliby.jpg'),
          tagline: 'Localize at a glance all nearby bike-sharing stations.',
          links: [
            {
              icon: 'fa-download',
              href: 'https://play.google.com/store/apps/details?id=com.licryle.veliby',
              title: 'Download for Android'
            }
          ],
          description: [
            'Veliby was born in Paris, from the need to have a much faster and convenient app than the official one, as well as curiosity on how to build Android applications. It then went on to support most bike shares in the world.',
            'With an　Android client and a middle-ware that ingests and optimizes any public bike data, it is a good full-stack project showcase.'
          ]
        }
      }
    })
  }
</script>

<style>
  .picture_label {
    width: 100%;
    color: white;
    background: #12579b99;
    margin: 0px;
    padding: 5px;
    padding-left: 10px;
    text-align: left;
    position: absolute;
    bottom: .5em;
    height: 2em;
    font-size: 1.5em;
    font-weight: 400;

    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
    left: 0;
  }

  .picture_label_lg {
    top: .5em;
    bottom: unset;
  }

</style>